import {
  USER_SETUP_REQUEST,
  USER_SETUP_SUCCESS,
  USER_SETUP_FAILURE,
  RESET_USER_SETUP_STATE,
} from "../../actionTypes/userSetup";

interface UserSetupState {
  isLoading: boolean;
  isProcessIntiated: boolean;
  error: string | null;
  success: boolean;
}

const initialState: UserSetupState = {
  isLoading: false,
  isProcessIntiated: false,
  error: null,
  success: false,
};

interface UserSetupAction {
  type: string;
  payload?: any;
}

const userSetupReducer = (
  state = initialState,
  action: UserSetupAction
): UserSetupState => {
  switch (action.type) {
    case USER_SETUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        success: false,
        isProcessIntiated: false,
      };
    case USER_SETUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isProcessIntiated: true,
        success: true,
        error: null,
      };
    case USER_SETUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload || "User setup failed. Please try again.",
        success: false,
        isProcessIntiated: false,
      };
    case RESET_USER_SETUP_STATE:
      return initialState;
    default:
      return state;
  }
};

export default userSetupReducer;

